<mat-card class="my-3 pb-2">
    <div class="row my-2">
        <div class="col d-flex flex-column">
            <div class="d-flex flex-row align-items-center mt-2 mb-3">
                <div class="col-4">
                    <h4 class="header-title">{{ title }}</h4>
                </div>
                <div class="col-4">
                    <div [ngClass]="getDecisionColor(trustDecision)" class="trust-decision text-center p-1">
                        {{ trustDecision }}
                    </div>
                </div>
            </div>
            <div class="row">
                <ng-container *ngFor="let item of data">
                    <div class="row">
                        <div class="col d-flex flex-col mb-2">
                            <div class="item-key mr-3">
                                {{ item.displayText }}
                            </div>
                        </div>
                        <div class="col d-flex flex-col mb-2">
                            <div class="item-value mr-3" [ngClass]="getColor(item.value)">
                                {{ item.value }}
                            </div>
                        </div>
                        <div class="col d-flex flex-col">
                            <div class="item-value mr-3">
                                {{ item.helpText }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</mat-card>